import { queryOptions } from "@tanstack/react-query";

import { trpc } from "~/libs/trpc.lib";

const DATASETS_QUERY_PREFIX = "datasets";

/**
 * The error behind a dataset's `FAILED` status. Kept in TanStack Query rather
 * than the Legend State store because it is a server-only read with no CRUD or
 * real-time surface: nothing about a failed publish is broadcast beyond the
 * status itself.
 *
 * Pass `enabled` only while the dataset is actually `FAILED`. Enabling it on the
 * transition (rather than keeping it warm) is also what refetches it, so a
 * second failure never shows the first one's message.
 */
export const datasetLastPublishErrorQueryOptions = (
  datasetId: string,
  enabled: boolean,
) =>
  queryOptions({
    queryKey: [DATASETS_QUERY_PREFIX, datasetId, "last-publish-error"] as const,
    queryFn: () => trpc.datasets.lastPublishError.query({ datasetId }),
    enabled,
  });
